import { Component, OnDestroy, OnInit } from "@angular/core";
import { IOption } from "ng-select";
import { Subscription } from "rxjs/Subscription";
import { BatchService } from "../batch.service";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from "ngx-bootstrap/modal";
import { ConfirmationService } from "primeng/primeng";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as moment from "moment";
import { PagerService } from "../../../../../common/services/Pagination.service";
import { environment } from "../../../../../../environments/environment";
import { ModalListBatchChildComponent } from "../list/modalListBatchChild.component";
import { ImageService } from "../../../../imageService";

declare var $: any;
var that;

@Component({
  selector: "app-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.css"]
})
export class MapComponent implements OnInit, OnDestroy {
  public FormFilterBatchStamp: FormGroup;
  model: any = {};
  bsModalRef: BsModalRef;
  bsModalImport: BsModalRef;
  bsModalDownload: BsModalRef;
  columns: any = {};
  excel: any = {};

  public qrm: string = "";
  numberID: number = 0;
  listDataImport: any = [];

  //status batch
  batch_not_pay = 0;
  batch_paid = 1;
  batch_activated = 2;
  is_printing = 1;
  list_status_filter: Array<IOption> = [
    { value: this.batch_paid.toString(), label: "Chưa kích hoạt" },
    { value: this.batch_activated.toString(), label: "Đã kích hoạt" }
  ];
  Infinity = Infinity;

  public currentPage: number = 1;
  public current_filter: any = {};
  public pager: any;
  public page_size: number = 10;
  public totalRow: number = 0;

  public list_items: any = [];

  code_chonggia = 1;
  code_baohanh = 2;
  code_tranhang = 3;
  code_dinhdanh = 5;

  public item_detail: any = {};
  public item_active: number = 0;
  has_list: boolean = true;
  loadingDetail: boolean = false;

  no_product = "assets/images/no_product.png";
  no_image = "assets/images/no-image.png";

  is_downloading_batch: boolean = false;
  subcribeModal: Subscription;

  constructor(
    private batchService: BatchService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private confirmationService: ConfirmationService,
    private pagerService: PagerService,
    private imageService: ImageService,
    private translate: TranslateService
  ) {
    that = this;

    this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
    this.updateTranslations();
    this.subcribeModal = this.modalService.onHide.subscribe(() => {
      this.current_filter.sort_by = "last_imported:desc";
      this.getListBatchImport();
    });
  }

  ngOnInit() {
    $(".selectpicker").selectpicker({
      style: "btn-select",
      iconBase: "icon",
      tickIcon: "wb-check"
    });

    this.createFormFilter();
    $("#status").select2({
      placeholder: this.translate.instant('TRANG_THAI'),
      allowClear: false,
      minimumResultsForSearch: -1
    });
    this.current_filter.sort_by = "last_imported:desc";
    this.getListBatchImport();
  }


  updateTranslations() {
    this.translate.get([
      'CHUA_KICH_HOAT',
      'DA_KICH_HOAT',
      'TRANG_THAI',
      'CHONG_GIA',
      'BAO_HANH',
      'TRAN_HANG',
      'DINH_DANH'
    ]).subscribe(translations => {
      this.list_status_filter = [
        { value: this.batch_paid.toString(), label: translations['CHUA_KICH_HOAT'] },
        { value: this.batch_activated.toString(), label: translations['DA_KICH_HOAT'] }
      ];
      setTimeout(() => {
        let currentVal = $("#status").val();
        if ($("#status").length) {
          $("#status").select2({
            placeholder: translations['TRANG_THAI'],
            allowClear: false,
            minimumResultsForSearch: -1
          });
          if (currentVal) { $("#status").val(currentVal).trigger('change'); }
        }
        if ($('.selectpicker').length) {
          $('.selectpicker').selectpicker({
            style: 'btn-select',
            iconBase: 'icon',
            tickIcon: 'wb-check',
            title: translations['CHON_DICH_VU']
          });
          $('.selectpicker').selectpicker('refresh');
        }
      }, 50);
    });
  }

  ngOnDestroy() {
    this.subcribeModal.unsubscribe();
  }

  createFormFilter() {
    this.FormFilterBatchStamp = this.fb.group({
      service: [[]],
      // batch_id: [null],
      status: [null],
      created_time_ranger: [null],
      name: [null],
      code: [null]
    });
  }

  onSubmit() { }

  submitFilterBatch(data: any = {}) {
    this.currentPage = 1;
    let data_filter: any = {};

    if (data.service && data.service.length > 0) {
      data_filter.service = data.service.toString();
    }

    if (data.code) {
      data_filter.code = data.code;
    }
    if (data.serial) {
      data_filter.name = data.name;
    }
    if ($("#status").val()) {
      data_filter.status = $("#status").val();
    }
    if (data.created_time_ranger) {
      data_filter.from = moment(data.created_time_ranger[0]).format(
        "YYYY-MM-DD"
      );
      data_filter.to = moment(data.created_time_ranger[1]).format("YYYY-MM-DD");
    }
    this.current_filter = data_filter;
    this.current_filter.sort_by = "last_imported:desc";
    this.getListBatchImport();
  }

  getListBatchImport(request: any = null) {
    let data_get: any = request ? request : this.current_filter;
    if (this.currentPage < 0) {
      this.currentPage = 1;
    }
    data_get.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    data_get.limit = this.page_size;
    // data_get.show_child = 1;
    this.batchService.getStampImport(data_get).subscribe(res => {
      if (res.error == false) {
        // this.setPage(this.currentPage);
        let list: any = [];
        for (let _data of res.data.batches) {
          let arr_services: any = this.convertServiceToText(_data.services);
          let obj = {
            id: _data.id,
            name: _data.name,
            quantity: _data.quantity,
            active_left: _data.active_left,
            has_child: _data.active_left != null,
            total_activated:
              _data.active_left == null
                ? 0
                : _data.quantity - _data.active_left,
            arr_services: arr_services,
            buy_services: _data.buy_services,
            status: _data.status,
            is_printing: _data.is_printing,
            image: this.imageService.readSrcImage(_data.image, "thumb_large"),
            last_imported: moment(_data.last_imported).format("DD/MM/YYYY")
          };
          list.push(obj);
        }
        this.list_items = list;
        this.item_active = 0;
        if (list.length > 0) {
          this.has_list = true;
          this.viewDetail(0);
        } else {
          this.has_list = false;
          this.item_detail = null;
        }
      } else {
        console.log("getBatchesList:error", res);
      }
    });
  }

  public viewDetail(i) {
    this.item_active = i;
    this.batchService
      .getBatchDetail(this.list_items[i].id)
      .toPromise()
      .then((res: any) => {
        if (!res.error) {
          this.loadingDetail = false;
          let is_paid: boolean = false;
          if (
            res.data.status == this.batch_paid ||
            res.data.status == this.batch_activated
          ) {
            is_paid = true;
          }
          let arr_services = this.convertServiceToText(res.data.services);
          this.item_detail = {
            name: res.data.name,
            id: res.data.id,
            created_time: res.data.created_time,
            created_time_f: moment(res.data.created_time).format("DD/MM/YYYY"),
            produce_time: res.data.produce_time,
            produce_time_f: moment(res.data.produce_time).format("DD/MM/YYYY"),
            guarantee_days: res.data.guarantee_days,
            guarantee_days_max: res.data.guarantee_days_max,
            quantity: res.data.quantity,
            quantity_imported: res.data.quantity_imported,
            force_update: res.force_update,
            last_imported: moment(res.data.last_imported).format("DD/MM/YYYY"),
            arr_services: arr_services,
            buy_services: res.data.buy_services,
            id_start: res.data.id_start,
            id_end: res.data.id_end,
            prefix_id: res.data.prefix_id,
            prefix: res.data.prefix,
            serial:
              this.formatSerial(res.data.id_start, res.data.prefix) +
              " – " +
              this.formatSerial(res.data.id_end, res.data.prefix),
            serial_start: this.formatSerial(res.data.id_start, res.data.prefix),
            status: res.data.status,
            is_paid: is_paid,
            is_printing: res.data.is_printing,
            counter: res.data.counter,
            counter_warning: res.data.counter_warning,
            only_icheck: res.data.only_icheck,
            product_id: res.data.product_id,
            product_name: res.data.product_name,
            product_image: this.imageService.readSrcImage(
              res.data.product_image,
              "thumb_medium"
            ),
            is_chonggia: this.checkService(
              res.data.services,
              this.code_chonggia
            ),
            is_baohanh: this.checkService(res.data.services, this.code_baohanh),
            is_tranhang: this.checkService(
              res.data.services,
              this.code_tranhang
            ),
            is_dinhdanh: this.checkService(
              res.data.services,
              this.code_dinhdanh
            ),
            is_manufacturer: res.data.is_manufacturer,
            show_vendor: res.data.show_vendor,
            show_distributor: res.data.show_distributor,
            messages: res.data.messages,
            has_child: res.data.active_left != null,
            active_left: res.data.active_left,
            isImportChild: true,
            user_created_name: res.data.user_created_name
          };
        }
      });
  }

  checkService(services_list: string, code_service: any) {
    if (services_list.indexOf(code_service.toString()) != -1) {
      return true;
    }
    return false;
  }

  ResetFormSearch() {
    $("#filter_service").selectpicker("val", "");
    $("#status")
      .val("")
      .trigger("change");
    this.FormFilterBatchStamp.reset();
  }

  convertServiceToText(service: string) {
    let arr_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_chonggia.toString()) != -1) {
      arr_services.push({ code: this.code_chonggia, name: this.translate.instant('CHONG_GIA') });
    }
    if (service.indexOf(this.code_baohanh.toString()) != -1) {
      arr_services.push({ code: this.code_baohanh, name: this.translate.instant('BAO_HANH') });
    }
    if (service.indexOf(this.code_tranhang.toString()) != -1) {
      arr_services.push({ code: this.code_tranhang, name: this.translate.instant('TRAN_HANG') });
    }
    if (service.indexOf(this.code_dinhdanh.toString()) != -1) {
      arr_services.push({ code: this.code_dinhdanh, name: this.translate.instant('DINH_DANH') });
    }
    return arr_services;
  }

  setSort(sort: string) {
    if (sort) {
      this.current_filter.sort_by = sort;
      this.getListBatchImport();
    }
  }

  setPage(page: number) {
    if (page < 1) {
      this.currentPage = 1;
      return;
    }
    this.pager = this.pagerService.getPager(
      this.totalRow,
      this.currentPage,
      this.page_size
    );
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.getListBatchImport();
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    } else {
      this.setPage(1); //toPage = 1;
    }
  }

  openImport(template) {
    this.bsModalImport = this.modalService.show(template, {
      class: "modal-lg"
    });
  }

  hideMapping() {
    this.bsModalImport.hide();
  }

  formatSerial(id, prefix) {
    let serial_f: string = "";
    id = id.toString();
    if (id && prefix) {
      let pad = "000000";
      let serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + "-" + serial;
    }
    return serial_f;
  }

  showDownloadBatch(templateDownload) {
    this.bsModalDownload = this.modalService.show(templateDownload);
  }

  downloadBatch() {
    if (Object.keys(this.columns).length <= 0) {
      this.toastr.warning(this.translate.instant('PHAI_CHON_IT_NHAT_MOT_COT'), this.translate.instant('THONG_BAO_CHAM'), {
        timeOut: 4000,
        positionClass: "toast-top-right"
      });
    } else {
      this.is_downloading_batch = true;
      let currentBatch = this.item_detail;
      let request: any = {};
      request.start = currentBatch.id_start;
      request.end = currentBatch.id_end;
      request.prefix_id = currentBatch.prefix_id; // dm, cai nay nhớ là prefix_id nhé, đéo phải batch_id như ở link download bên dưới đâu nhé. LOL.@chuongnv
      request.prefix = currentBatch.prefix;
      request.fields = "&fields=";
      if (this.columns.serial) request.fields += "serial";
      if (this.columns.qrm) {
        if (request.fields.length <= 0) request.fields += "qrm";
        else request.fields += ",qrm";
      }
      if (this.columns.qri) {
        if (request.fields.length <= 0) request.fields += "qri";
        else request.fields += ",qri";
      }
      if (this.columns.sms) {
        if (request.fields.length <= 0) request.fields += "sms";
        else request.fields += ",sms";
      }
      // let ext = 'xlsx';
      // let filename = '#'+this.item_detail.id+'_'+this.item_detail.name+'.'+ext;
      let query =
        "?start=" + request.start + "&end=" + request.end + request.fields;
      if (localStorage.getItem("Access-Token")) {
        query += "&Access_Token=" + localStorage.getItem("Access-Token");
      }
      let url =
        environment.api_evs +
        "/stamps/batch/" +
        currentBatch.id +
        "/download" +
        query;
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display: none");
      a.href = url;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove(); // remove the element
      this.columns = {};
    }
  }

  showPopupLogsActiveBatchChild() {
    // this.isActiveBatch = false;
    const initialState = {
      batch_detail: this.item_detail
    };
    this.bsModalRef = this.modalService.show(ModalListBatchChildComponent, {
      initialState,
      class: "modal-list-batch-child"
    });
    this.bsModalRef.content.closeBtnName = this.translate.instant('QUAY_LAI');
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/map/map.component.ts